import type { BusinessInfo } from "../api/types";
import raw from "./business.json";

/**
 * The house — the bundled copy. It seeds the server's "business" document
 * on first start and is the fallback when the API is unreachable; the live
 * copy (hours, address, phone …) is edited from /dashboard.
 */
export const BUSINESS: BusinessInfo = raw as BusinessInfo;
